import React from "react"
import {Button, RelativeSwitch, SortedTable} from "../components/common/common";
import {Route} from "react-router-dom";
import {reduxWrapper} from "../globalState";
import {objectToArray, relativePath, saveMessage, sortTable} from "../lib/tools";
import {FormInput, FormList, ValidateForm} from "../components/common/formValidation";

const VendorTool = (props) => (
	<RelativeSwitch>
		<Route path="/:id" render={({match: {params: {id}}}) => <VendorEdit id={id}/>}/>
		<Route component={VendorOverview}/>
	</RelativeSwitch>
);

class VendorOverviewRender extends React.Component {
	
	columns = {
		id: {
			name: "ID",
			sortable: true,
			parse: val => parseInt(val, 10)
		},
		name: {
			name: "Name",
			sortable: true
		},
		products: {
			name: "Products",
			sortable: true
		},
		sales: {
			name: "Sales",
			sortable: true
		},
		commission: {
			name: "Commission",
			sortable: true,
			render: val => val + "%"
		},
		salesTotal: {
			name: "Sales Total",
			sortable: true
		}
	};
	
	state = {
		vendors: []
	};
	
	vendors = [];
	
	componentWillMount() {
		this.props.awaitVendors(x => {
			this.vendors = objectToArray(x);
			this.setState({vendors: this.vendors})
		});
	}
	
	tableChange({order, orderAsc}) {
		this.setState({vendors: sortTable(this.vendors, this.columns, order, orderAsc)});
	}
	
	render() {
		return (
			<div id="vendorTool" className="vendorList">
				<SortedTable
					rows={this.state.vendors}
					columns={this.columns}
					onChange={val => this.tableChange(val)}
					pages={false}
					history={this.props.history}
					redirect={relativePath("") + "/"}
					redirectProp="id"/>
			</div>
		);
	}
}

export const VendorOverview = reduxWrapper("getApiCall", "loadVendors")(VendorOverviewRender);

class VendorEditRender extends React.Component {
	
	state = {
		id: null,
		name: "",
		commission: 0,
		address: "",
		zipcode: null,
		shipping: []
	};
	
	componentWillMount() {
		this.props.awaitVendors(vendors => this.setState(vendors[this.props.id]));
	}
	
	save(vendor) {
		console.log(vendor);
		this.props.updateVendors({id: this.props.id, data: vendor}).then(() => this.props.sendMessage(saveMessage()));
	}
	
	render() {
		
		return (
			<div id="vendorTool" className="vendorDetails">
				<h2 className="name">{this.state.name}</h2>
				<br/>
				<ValidateForm values={this.state} onChange={val => this.setState(val)} onSubmit={val => this.save(val)}>
					
					<h3>Basic Info</h3>
					<FormInput name="name" req/>
					<FormInput type="number" name="commission" req/>
					
					<h3>Address</h3>
					<FormInput name="address"/>
					<FormInput type="number" name="zipcode"/>
					
					<h3>Shipping</h3>
					<FormList name="shipping">
						{({value = {}, onChange}) => (
							<div className="shippingRow">
								<FormInput name="name" value={value && value.name} onChange={name => onChange({...value, name})}/>
								<FormInput name="price" value={value && value.price} type="number" onChange={price => onChange({...value, price})}/>
								<FormInput name="under" value={value && value.under} type="number" onChange={under => onChange({...value, under})}/>
								<FormInput name="over" value={value && value.over} type="number" onChange={over => onChange({...value, over})}/>
							</div>
						)}
					</FormList>
					<Button submit className="floatingBtn">Save</Button>
				</ValidateForm>
			</div>
		);
	}
}

const VendorEdit = reduxWrapper("loadVendors", "updateVendors", "getSendMessage")(VendorEditRender);

export default VendorTool;


// WEBPACK FOOTER //
// ./src/admin/vendorTool.js